"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/commons/app.service.ts');
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const of_1 = require("rxjs/observable/of");
const vasat_1 = require("vasat");
const models_1 = require("./models");
const ng_qmap_1 = require("ng-qmap");
const platform_browser_1 = require("@angular/platform-browser");
const _4d_mapper_1 = require("4d-mapper");
const explorer_dialogs_1 = require("./dialogs/explorer.dialogs");
const align_bounds_component_1 = require("./dialogs/align-bounds/align-bounds.component");
const acl_service_1 = require("./acl/acl.service");
const Constants_1 = require("./Constants");
const environment_1 = require("../../environments/environment");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
const ui_manager_service_1 = require("../xs/services/ui/ui-manager.service");
class AppService {
    constructor(V, fourD, titleService, permissions, uiManager) {
        this.V = V;
        this.fourD = fourD;
        this.titleService = titleService;
        this.permissions = permissions;
        this.uiManager = uiManager;
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.debug = Constants_1.Constants.debug_off;
        this.objectMetas = [];
        this.curAccountObs = new rxjs_1.BehaviorSubject(null);
        this.accLoading = false;
        // Toolbar
        this.toolbar = { title: "" };
        this.themes = [{ name: "THEME.LIGHT", class: "" }, { name: "THEME.DARK", class: "dark-theme" }];
        this.curThemeClass = "";
        this.languages = [{ name: 'English', code: 'en' }, { name: '日本語', code: 'ja' }, { name: '中文', code: 'zh' }];
        //{name:'Español',code:'es'}]
        // user access / ACL
        // available roles
        this.roles = null;
        // incoming language
        this.language = null;
        DEBUG_1.DEBUG.log('/app/commons/app.service.ts');
        V.registerClass(vasat_1.User);
        V.registerClass(_4d_mapper_1.Project);
        V.onLogout.subscribe(_ => {
            delete localStorage['last4d_token'];
            delete localStorage['last4d_secret'];
            this.myProfile = null;
            // Invalidate all vasat session
            this.V.invalidateSession();
            // Go to root page on logout
            //this.router.navigateByUrl(AppRoutes.AUTH)
        });
    }
    onReady() {
        if (this.accounts) {
            if (this.debug) {
                console.log('app.service :: onReady() observableOf');
            }
            return of_1.of(this);
        }
        else if (this._loading) {
            if (this.debug) {
                console.log('app.service :: onready() _loading');
            }
            return this._loading;
        }
        else {
            if (this.debug) {
                console.log('app.service :: onReady() Vasat setup');
            }
            return this._loading = this.V.onReady().pipe(operators_1.mergeMap(v => {
                this.isSharedLogin = this.V.localSession() && !this.V.localSession().user;
                // moved this here so share links dont die
                this.refreshMe().subscribe();
                return this.refreshData().pipe(operators_1.map(r => {
                    this._loading = null;
                    if (this.debug) {
                        console.log("app.service :: onReady() Vasat ready");
                    }
                    return this;
                }));
            }), operators_1.share());
        }
    }
    // let e = document.getElementById('loading-app'); if ( e ) { e.remove(); }
    refreshMe() {
        // console.log ( 'app.service :: refreshMe()');
        if (this.debug) {
            console.log("app.service :: refreshMe()");
        }
        // fetch the api/me user object as well as Account list that this user belongs to
        return this.V.refreshMeUser().pipe(operators_1.map(up => {
            this.myProfile = up;
            // init Projects/Dashboard screen quick guides show/hide setting
            if (!this.myProfile["hideProjectQuickGuidesOnStart"])
                this.uiManager.toggleQuickGuidePopup("dashboard", true);
            if (!this.myProfile.json)
                this.myProfile.json = {}; // Simply make json field empty rather than null if it comes null from the server.
        }, e => this.myProfile = null));
    }
    /**
     * Gets all the app data. The order of the requests matters
     */
    refreshData() {
        // console.log ( 'app.service :: refreshData()');
        return this.V.searchByObject(models_1.ObjectMeta).queryObservable().pipe(operators_1.tap(o => this.objectMetas = o.items));
    }
    logout() {
        return this.V.logoutObservable().pipe(operators_1.map(_ => {
        }));
    }
    getUserLocale() {
        if (navigator.languages != undefined)
            return navigator.languages[0];
        else
            return navigator.language;
    }
    /**
     * Loads the vasat instace config at '{host}/vasat'
     */
    loadInstanceConfig() {
        if (this.debug) {
            console.log('app.service :: loadInstanceConfig()', this.V);
        }
        var start = window.performance.now();
        return this.V.api("/4dinfo").pipe(operators_1.map(config => {
            config['language'] = this.language;
            this.siteSettings = config;
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = config.fav_icon || this.V.config.host + "/4dinfo/favicon.png";
            document.getElementsByTagName('head')[0].appendChild(link);
            if (config.app_name)
                this.titleService.setTitle(config.app_name);
            this.vasatInstance = config;
            // console.log('siteSettings',this.siteSettings);
            if (environment_1.environment.production) {
                this.curThemeClass = config.app_branding && config.app_branding ? config.app_branding : '';
            }
            var time = window.performance.now() - start;
            ;
            if (this.debug) {
                console.log('app.service :: loadInstanceConfig() [Vasat] took ' + time + ' ms', config, environment_1.environment);
            }
        }));
    }
    /**
     * Request email verification to register.
     */
    requestEmailRegistration(email) {
        return this.V.api("/access/register", "post", { email: email }).pipe(operators_1.map(config => this.vasatInstance = config));
    }
    /**
     * Returns the sufix for the given access group uid. Normally is "_users" or "_admins"
     * @param uid The access group uid to qeury
     */
    getAccessGroupSufix(accessGroupUid, accountUid) {
        return accessGroupUid.replace(accountUid, "");
    }
    showInputDialogForT(dialog, model, tt) {
        let dialogRef = dialog.open(explorer_dialogs_1.APIDialog, {
            minWidth: '350px',
            // height: '80%',
            data: { model: model, apis: [tt], title: 'TYPES.' + tt.uid }
        });
        return dialogRef.afterClosed();
    }
    startAdHoc(comp, d, tt, isNew, ttBatch = null) {
        return tt.apis.queryObservable().flatMap(res => {
            var onReady = null;
            // must do this here, if dialog box makes it, this method doesnt have access to reference
            if (!d.initParams)
                d.initParams = {};
            var model = d.initParams;
            var next;
            if (tt.needsCRS) {
                if (!d['unalignedBounds']) {
                    return rxjs_1.throwError("Dataset " + d.name + " has no boundaries detected. The pre-processing window cannot start.");
                }
                let dialogRef = comp.open(align_bounds_component_1.AlignBoundsDialog, {
                    width: '80%',
                    data: { dataset: d }
                });
                next = dialogRef.afterClosed();
            }
            else {
                next = rxjs_1.of(true);
            }
            return next.pipe(operators_1.flatMap(s => {
                if (!s)
                    return;
                //console.log(model)
                // when theres account specific ProcessorAPIs
                /* if (res.items.length) {
                    // TODO: for now just do first one
                    var api = res.items[0]
                
                    onReady = api.needsInput || res.items.length > 1 ? this.showInputDialog(dialog, model, res.items, tt) : observableOf({
                    api: api,
                    model: {}
                    })
            
                }*/
                // otherwise default transformType
                //  else {
                onReady = tt['needsInput'] || res.items.length > 1 ? this.showInputDialogForT(comp, model, tt) : of_1.of({ model: model });
                //}
                return onReady.pipe(operators_1.flatMap(params => {
                    if (!params) {
                        if (isNew)
                            d.destroyObservable().subscribe();
                        return;
                    }
                    if (ttBatch)
                        params.model.batch_id = 'folder_' + ttBatch.id;
                    // when its an api specific tak that to end otherwise default
                    //var extraURL = params.api ? ('/' + params.api.id) : ''
                    d.initParams = params.model;
                    d.saveObservable();
                    return d.applyTransform(tt, params.model);
                }));
            }));
        });
    }
    sendSupportTicket(ticketRequest) {
        // If subject is empty then we populate it with a generic one
        if (!ticketRequest.subject) {
            var settings = Object.assign({}, this.siteSettings, environment_1.environment);
            var here = settings.app_name + ' ' + (settings.production ? 'Prod' : 'Beta') + '[' + settings.app_version + ']';
            var name = (this.fourD && this.fourD.activeUser) ? this.fourD.activeUser.name : "NA";
            ticketRequest.subject = 'Contact Form from "' + name + '" (in-app: ' + here + ' )';
        }
        return this.V.api('/ticket/' + this.fourD.activeTeam.id, 'post', ticketRequest);
    }
    showContactUs() {
        return !(this.siteSettings && this.siteSettings["hide_contact_form"]);
    }
    apiDetectWmsUrl(req) {
        return this.V.api("/api/DetectURL", "post", req);
    }
    apiCreateWmsLayers(folder, req) {
        return this.V.api("/api/Folder/" + folder.id + "/CreateLayer", "post", req);
    }
}
exports.AppService = AppService;
class VasatQMAPService extends ng_qmap_1.QMAPService {
    constructor(service) {
        super();
        this.service = service;
    }
    objectTypeQMap(objString) {
        return [{ id: 'name', type: 'shorttext', title: 'Name', required: true }];
    }
    objectsForQMap(qMap, searchString, superModel) {
        var query = this.service.V.searchByObject(this.service.V.registeredClassForString(qMap.obj_type));
        if (searchString && qMap.filter) {
            query = query.complexQuery({
                op: 'and',
                items: [
                    qMap.filter,
                    {
                        op: 'like',
                        col: 'name',
                        val: '~' + searchString + '~'
                    }
                ]
            });
        }
        else if (qMap.filter) {
            query = query.complexQuery(qMap.filter);
        }
        else if (searchString)
            query = query.contains('name', searchString);
        return query.queryObservable().pipe(operators_1.map(i => i.items));
    }
    isModel(obj) {
        return !!obj && obj.toJSON;
    }
    findCachedModel(qmap, id) {
        return this.service.V.findCached(qmap.obj_type, id);
    }
    makeModel(qmap) {
        var clazz = this.service.V.registeredClassForString(qmap.obj_type);
        return new clazz(this.service.V);
    }
    canWrite(sm) {
        return sm.permissions ? sm.permissions.find(p => 'api_update') : true;
    }
    canDelete(sm) {
        return sm.permissions ? sm.permissions.find(p => 'api_delete') : false;
    }
    absURL(m, s) {
        return m.file(s) + '?access_token=' + this.service.V.token;
    }
}
exports.VasatQMAPService = VasatQMAPService;
